module.exports = __webpack_public_path__ + "img/product.8a3251d7.png";